import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function HomeBoxRAG({
    title,
    total,
    red,
    amber,
    green
})
{

    //========================================================
    // Container
    //========================================================

    const container =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "100%",

        boxSizing:
            "border-box"
    };


	//========================================================
	// Title
	//========================================================

	const titleContainer =
	{
	    display:
	        "flex",

	    justifyContent:
	        "flex-start",

	    alignItems:
	        "center",

	    height:
	        "40px",

	    paddingLeft:
	        "10px",

	    flexShrink:
	        0,

	    fontSize:
	        "14px",

	    fontWeight:
	        600,

	    color:
	        "#263746",

	    letterSpacing:
	        "0.1px"
	};


    //========================================================
    // 2 x 2 grid
    //========================================================

    const grid =
    {
        display:
            "flex",

        flexWrap:
            "wrap",

        width:
            "100%",

        gap:
            "8px",

        padding:
            "0px 10px 10px 10px",

        boxSizing:
            "border-box"
    };


    //========================================================
    // Metric box
    //========================================================

    const box =
    {
        display:
            "flex",

        width:
            "calc(50% - 4px)",

        height:
            "38px",

        alignItems:
            "stretch",

        background:
            "rgba(248,250,252,0.82)",

        border:
            "1px solid rgba(12,53,88,0.10)",

        borderRadius:
            "0px",

        boxShadow:
            "none",

        overflow:
            "hidden",

        boxSizing:
            "border-box"
    };


    //========================================================
    // Label
    //========================================================

    const label =
    {
        display:
            "flex",

        alignItems:
            "center",

        flex:
            1,

        paddingLeft:
            "12px",

        fontSize:
            "13px",

        fontWeight:
            500,

        color:
            "#4b5d6d",

        whiteSpace:
            "nowrap"
    };


    //========================================================
    // Figure
    //========================================================

    const figureBase =
    {
        width:
            "64px",

        minWidth:
            "64px",

        display:
            "flex",

        justifyContent:
            "center",

        alignItems:
            "center",

        borderRadius:
            "0px",

        fontSize:
            "15px",

        fontWeight:
            700,

        color:
            "#ffffff"
    };


    //========================================================
    // Direction icon
    //========================================================

    const iconContainer =
    {
        width:
            "34px",

        minWidth:
            "34px",

        display:
            "flex",

        justifyContent:
            "center",

        alignItems:
            "center"
    };


    const icon =
    {
        width:
            "17px",

        height:
            "17px",

        color:
            "rgba(38,55,70,0.50)"
    };


    //========================================================
    // Metric colours
    //========================================================

    const totalBg =
    {
        background:
            "linear-gradient(180deg, #eef1f4 0%, #dfe3e7 100%)",

        color:
            "#354554"
    };


    const redBg =
    {
        background:
            "linear-gradient(180deg, #d82c3b 0%, #bd1727 100%)"
    };


    const amberBg =
    {
        background:
            "linear-gradient(180deg, #ffb23f 0%, #ed9514 100%)"
    };


    const greenBg =
    {
        background:
            "linear-gradient(180deg, #3caf64 0%, #26934e 100%)"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={container}>

            <div style={titleContainer}>
                {title}
            </div>


            <div style={grid}>

                {/* ==========================================
                    TOTAL
                ========================================== */}

                <div style={box}>

                    <div style={label}>
                        Total:
                    </div>

                    <div
                        style={{
                            ...figureBase,
                            ...totalBg
                        }}
                    >
                        {total}
                    </div>

                    <div style={iconContainer}>

                        <FontAwesomeIcon
                            icon="arrow-up"
                            style={icon}
                        />

                    </div>

                </div>


                {/* ==========================================
                    RED
                ========================================== */}

                <div style={box}>

                    <div style={label}>
                        Red:
                    </div>

                    <div
                        style={{
                            ...figureBase,
                            ...redBg
                        }}
                    >
                        {red}
                    </div>

                    <div style={iconContainer}>

                        <FontAwesomeIcon
                            icon="arrow-up"
                            style={icon}
                        />

                    </div>

                </div>


                {/* ==========================================
                    AMBER
                ========================================== */}

                <div style={box}>

                    <div style={label}>
                        Amber:
                    </div>

                    <div
                        style={{
                            ...figureBase,
                            ...amberBg
                        }}
                    >
                        {amber}
                    </div>

                    <div style={iconContainer}>

                        <FontAwesomeIcon
                            icon="equals"
                            style={icon}
                        />

                    </div>

                </div>


                {/* ==========================================
                    GREEN
                ========================================== */}

                <div style={box}>

                    <div style={label}>
                        Green:
                    </div>

                    <div
                        style={{
                            ...figureBase,
                            ...greenBg
                        }}
                    >
                        {green}
                    </div>

                    <div style={iconContainer}>

                        <FontAwesomeIcon
                            icon="arrow-down"
                            style={icon}
                        />

                    </div>

                </div>

            </div>

        </div>

    );

}